import driverAllocation from '../driver/reducer';
import vehicleRelocation from '../vehicle/reducer';
import { combineReducers } from 'redux';

const relocation = combineReducers({
  driverAllocation,
  vehicleRelocation
});

export default relocation;



// WEBPACK FOOTER //
// ./src/features/relocations/reducer/index.js